const Entidade = {
  FACULDADE_UNYLEYA: 14,
  GRADUACAO: 352,
  FACULDADE_UNYLEYA_CURSOS_EXTENSAO: 1408,
};

export default Entidade;
